// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.extra-info__character-limit[data-v-21a85b78] {\n  margin: 2px 0 9px 5px;\n  padding-bottom: 8px;\n}\n.extra-info__textarea[data-v-21a85b78] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
